import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';


export default function Crossrope(props) {
  return (
    <SvgIcon {...props}>
      <g>
        <path
          d="M45.7254 1.09901C45.0738 1.20902 44.2783 1.51368 43.6098 1.8945C43.0766 2.20762 42.9666 2.30071
          42.298 2.96926C41.2317 4.04403 40.6647 5.3896 40.5886 7.07368C40.5463 7.89456 40.5716 8.16537 40.724
          8.76622C41.2148 10.7211 42.5435 12.2782 44.4137 13.1076C45.2685 13.48 45.8439 13.59 46.9525
          13.59C48.1119 13.59 48.772 13.4461 49.7452 12.9637C50.2953 12.6929 51.2431 11.9821 51.3362
          11.762C51.3785 11.6774 50.0668 10.281 49.8806 10.2218C49.8383 10.2049 49.6267 10.3234 49.4152
          10.4842C49.2036 10.6534 48.8143 10.8904 48.5435 11.0173C48.0865 11.2458 47.985 11.2627 46.9948
          11.2627C45.937 11.2627 45.9201 11.2627 45.3023 10.9496C44.7522 10.6788 44.0921 10.1456 43.7198
          9.68019C43.1105 8.89316 42.8312 7.14138 43.1528 6.04969C43.5505 4.71258 44.3206 3.90016 45.6662
          3.3924C46.1147 3.23161 46.394 3.18083 46.9525 3.18083C47.9173 3.18083 48.5858 3.42625 49.5929
          4.16251C49.7283 4.2556 49.8383 4.27252 49.9737 4.22175C50.2699 4.12019 51.3447 2.9608 51.2854
          2.80847C51.1246 2.40226 49.5167 1.44598 48.552 1.1921C47.8834 1.01438 46.504 0.972065
          45.7254 1.09901Z"
          fill="currentColor"
        />
        <path
          d="M68.8371 1.10913C67.2969 1.40533 65.9259 2.20082 65.0289 3.3179C64.1403 4.40959 63.7087 5.55206
          63.6071 6.99072C63.4294 9.8088 65.2151 12.3899 67.9824 13.3124C68.6424 13.5324 68.8117 13.5493
          69.9288 13.5493C71.2066 13.5493 71.4182 13.507 72.5099 13.0585C74.3463 12.2968 75.785 10.452
          76.1489 8.38706C76.3097 7.45616 76.3097 7.10073 76.1404 6.22061C75.7596 4.20648 74.5579 2.60703
          72.7553 1.70998C71.5452 1.11759 70.0303 0.880639 68.8371 1.10913ZM71.122 3.47023C72.3237 3.83412
          73.2377 4.72271 73.7455 5.99212C74.541 8.02317 73.3816 10.4012 71.2236 11.1459C69.5226 11.7298
          67.6523 11.1205 66.6029 9.64801C66.1375 8.99638 65.9344 8.36167 65.8836 7.43078C65.8498 6.72837
          65.8667 6.57604 66.0782 6.00904C66.4929 4.87504 67.2292 4.09647 68.3547 3.59717C69.1333 3.25866
          70.2588 3.20788 71.122 3.47023Z"
          fill="currentColor"
        />
        <path
          d="M112.75 1.10929C111.396 1.32932 109.932 2.19252 109.027 3.30113C108.536 3.89352 107.977 4.95982
          107.791 5.63684C107.588 6.40695 107.546 7.76944 107.706 8.59879C107.96 9.92743 108.866 11.4084
          109.915 12.2293C111.083 13.1433 112.098 13.5072 113.639 13.5664C114.587 13.6087 114.849 13.5833
          115.458 13.431C117.303 12.9655 118.776 11.7808 119.605 10.0798C120.468 8.32798 120.477 6.4408
          119.63 4.62131C118.886 3.02186 117.591 1.91325 115.797 1.33778C114.663 0.973887 113.926 0.914648
          112.75 1.10929ZM114.79 3.38576C116.177 3.68195 117.286 4.67209 117.811 6.08536C118.073 6.77084
          118.073 7.97255 117.819 8.64956C117.616 9.19964 117.295 9.69894 116.88 10.1221C116.457 10.5537
          116.304 10.6637 115.687 10.9683C113.452 12.0685 110.626 10.7991 109.991 8.39568C109.924 8.15873
          109.873 7.65943 109.873 7.28707C109.881 5.76378 110.728 4.40975 112.09 3.74119C113.004 3.29267
          113.825 3.18265 114.79 3.38576Z"
          fill="currentColor"
        />
        <path
          d="M80.3802 1.14285C79.3816 1.33749 78.4338 1.95527 77.9938 2.68306C77.4268 3.63089 77.3337
          4.64641 77.723 5.68733C77.8668 6.07661 78.0445 6.32203 78.51 6.77902C79.1024 7.37141 79.6101
          7.6676 81.3535 8.46309C82.3182 8.90316 83.0375 9.65634 83.046 10.2318C83.046 10.5872 82.6567
          11.2896 82.3436 11.4758C81.7851 11.8143 80.7188 11.662 79.6609 11.095C79.3563 10.9342 78.95
          10.7142 78.7554 10.6126L78.4 10.4349L78.2307 10.638C78.1376 10.748 77.943 11.0611 77.7991
          11.3235C77.6553 11.5858 77.4945 11.8143 77.4437 11.8313C77.2321 11.9074 77.486 12.1698 78.2307
          12.6606C79.1024 13.2361 79.7455 13.4646 80.8711 13.6C81.802 13.71 82.4621 13.6507 83.1899
          13.3799C84.18 13.0076 84.8232 12.4321 85.2971 11.5012C85.5171 11.0611 85.5425 10.9257 85.5425
          10.1641C85.5425 9.39399 85.5171 9.26705 85.2802 8.76775C84.7978 7.75223 84.0615 7.19369
          82.0136 6.26279C80.7611 5.69579 80.3802 5.45883 80.0841 5.04416C79.7625 4.59564 79.7371
          4.35022 79.9571 3.86784C80.3041 3.13159 80.8795 2.91156 81.8781 3.13159C82.4875 3.26699
          82.8598 3.43624 83.6553 3.89323C83.96 4.07095 84.0869 4.1048 84.2139 4.0371C84.3916 3.94401
          85.1617 2.73384 85.1617 2.55612C85.1617 2.25147 84.0446 1.59984 83.0375 1.32057C82.369
          1.13439 80.9134 1.0413 80.3802 1.14285Z"
          fill="currentColor"
        />
        <path
          d="M89.9854 1.15126C88.4367 1.439 87.2604 2.67455 87.1419 4.13014C86.9896 5.89885 87.9205 7.10055
          90.2393 8.133C91.3733 8.6323 91.7372 8.85233 92.1349 9.25008C92.8288 9.95248 92.8458 10.5533
          92.1941 11.2304C91.7964 11.645 91.7879 11.645 91.2463 11.645C90.4424 11.6366 90.0277 11.5181
          89.1137 11.0103C88.6567 10.7564 88.1997 10.5449 88.0982 10.5449C87.9543 10.5449 87.802 10.7141
          87.455 11.2811L86.9896 12.0089L87.3281 12.3051C87.8189 12.7283 88.5806 13.1514 89.2999
          13.3968C89.85 13.583 90.0954 13.6168 91.0432 13.6253C92.0164 13.6338 92.2111 13.6084
          92.6934 13.4307C93.8359 12.9991 94.4706 12.449 94.9276 11.4758C95.4438 10.3841 95.2238
          8.92003 94.386 7.98913C93.8359 7.37136 93.1589 6.94822 91.661 6.2712C89.9938 5.50956
          89.4776 5.05257 89.4776 4.32478C89.4776 3.74085 89.9685 3.15693 90.5608 3.04691C91.1532
          2.9369 92.2365 3.25848 93.2012 3.83394C93.4551 3.98627 93.692 4.11321 93.7259 4.11321C93.9375
          4.11321 94.8599 2.67455 94.7753 2.46299C94.6906 2.22603 93.7259 1.68442 92.905 1.41361C92.2534
          1.19358 91.9064 1.13434 91.2209 1.10895C90.7555 1.09203 90.1969 1.10895 89.9854 1.15126Z"
          fill="currentColor"
        />
        <path
          d="M53.1388 1.30373C53.1134 1.34604 53.0965 4.08796 53.0965 7.39688V13.4139L53.3673 13.4646C53.5196
          13.49 54.0189 13.507 54.4843 13.49L55.3306 13.4646L55.3729 11.0697C55.3983 9.75798 55.4406 8.68321
          55.4829 8.68321C55.5168 8.68321 55.9568 8.68321 56.4561 8.68321H57.3701L58.5888 11.0951L59.8158
          13.507H60.9752H62.1431V13.27C62.1431 13.1431 61.8469 12.5168 61.4661 11.8229C61.0937 11.1543
          60.7891 10.5873 60.7891 10.5704C60.7891 10.5535 60.5606 10.1388 60.2813 9.64796C60.002 9.15712
          59.7735 8.70014 59.7735 8.63244C59.7735 8.56474 59.8582 8.48011 59.9682 8.43779C60.2813 8.31932
          61.026 7.76924 61.3391 7.43073C62.0839 6.63524 62.4308 5.45046 62.2362 4.39262C62.1769 4.0795
          62.0415 3.62251 61.9315 3.38556C61.6607 2.81009 60.8568 1.98075 60.3067 1.70994C59.4181 1.26988
          59.1219 1.23603 56.033 1.23603C54.4674 1.23603 53.1642 1.26988 53.1388 1.30373ZM58.7495
          3.35171C59.4858 3.56327 60.0443 4.29953 60.0443 5.0781C60.0443 5.55201 59.6974 6.16133 59.2742
          6.44059C58.8088 6.74525 58.3179 6.82142 56.7777 6.80449L55.3729 6.78757V5.02732V3.26708H56.9216C57.7679
          3.26708 58.5888 3.30093 58.7495 3.35171Z"
          fill="currentColor"
        />
        <path
          d="M97.0941 7.32068V13.3969L98.135 13.4477C98.702 13.4731 99.1928 13.4646 99.2182 13.4308C99.2521
          13.4054 99.2944 12.3306 99.3282 11.0527C99.3536 9.77486 99.379 8.71702 99.379 8.7001C99.379
          8.69164 99.8191 8.68317 100.352 8.68317H101.317L102.282 10.6042C102.815 11.6705 103.365 12.7453 103.492
          12.9992L103.737 13.4646L104.905 13.49L106.065 13.5154V13.2954C106.065 13.033 105.726 12.3475 104.575
          10.2826C104.093 9.41943 103.695 8.66625 103.695 8.61547C103.695 8.5647 103.78 8.49699 103.89
          8.46314C104.152 8.37852 104.964 7.81998 105.235 7.53224C106.86 5.79739 106.395 2.86083 104.313
          1.72683C103.483 1.26984 103.153 1.23599 99.9968 1.23599H97.0941V7.32068ZM102.976 3.45322C103.627
          3.80865 104.118 4.71416 104 5.3404C103.924 5.74661 103.467 6.31361 103.018 6.5675C102.654 6.7706
          102.578 6.77906 101.021 6.79599L99.396 6.80445L99.3452 6.49979C99.3198 6.33054 99.2944 5.52658
          99.2944 4.72262V3.25011L101.012 3.28396C102.4 3.30935 102.773 3.33474 102.976 3.45322Z"
          fill="currentColor"
        />
        <path
          d="M122.228 7.31225C122.228 12.7876 122.245 13.4054 122.364 13.4562C122.44 13.4816 122.931 13.507
          123.464 13.507H124.429L124.446 12.7622C124.454 12.356 124.463 11.3574 124.471 10.545V9.06404L125.994
          9.01326C126.832 8.97941 127.653 8.91171 127.814 8.86093C129.117 8.45472 130.09 7.45612 130.446
          6.16979C130.987 4.20644 129.997 2.24309 128.085 1.47298C127.619 1.2868 127.484 1.27834 124.919
          1.25295L122.228 1.22757V7.31225ZM127.492 3.59712C127.949 3.89332 128.33 4.47725 128.381
          4.98501C128.432 5.47585 128.068 6.18671 127.594 6.51676C127.145 6.82142 126.739 6.89758
          125.512 6.90604C124.615 6.90604 124.513 6.88912 124.513 6.75372C124.513 6.67755 124.488 6.16979
          124.463 5.63664C124.437 5.10349 124.446 4.36723 124.471 4.00333L124.53 3.35171H125.817C127.094
          3.35171 127.103 3.35171 127.492 3.59712Z"
          fill="currentColor"
        />
        <path
          d="M132.299 7.31225V13.3969L134.017 13.4477C134.956 13.4816 136.666 13.507 137.817 13.507H139.907L139.949
          13.0584C139.975 12.8215 139.992 12.3476 139.983 12.026V11.4336L137.258 11.3913L134.542 11.349L134.516
          9.80875L134.499 8.26008L136.843 8.24315L139.196 8.21776L139.221 7.22763L139.247 6.22903L136.894
          6.2121L134.542 6.18671L134.516 4.72266L134.499 3.26708H137.19H139.89L139.949 2.61545C139.975
          2.26002 140 1.80303 140 1.59992V1.23603H136.149H132.299V7.31225Z"
          fill="currentColor"
        />
        <path
          d="M7.90454 0.783389C7.19384 1.20219 6.58467 1.54485 5.98819 1.91289C4.09722 3.13124 2.422 4.56533
          1.47017 6.67205C1.25442 7.14161 1.10213 7.67464 1.03867 8.18228C0.822924 9.94634 1.83821 11.1774
          3.74187 11.5454C5.98819 11.9769 8.08222 11.4185 9.92242 10.2382C11.9276 8.95644 13.7932 7.4462
          15.6588 5.97404C17.9051 4.20998 20.126 2.42054 22.7404 1.21488C25.2279 0.0599976 27.7914 -0.460336
          30.482 0.504185C31.2053 0.770698 31.9287 1.11336 32.5633 1.55754C34.6066 2.95356 35.1776 5.55523
          34.0355 8.06806C33.0202 10.3017 31.2561 11.8119 29.1748 12.9795C28.4133 13.411 27.6011 13.7537
          26.8142 14.1344C26.7762 14.0709 26.7508 14.0202 26.7127 13.9567C26.9792 13.7917 27.233 13.6268
          27.4996 13.4745C29.619 12.2942 31.4719 10.8347 32.7663 8.74069C32.9059 8.51225 33.0455 8.27112
          33.1471 8.0173C34.1243 5.70752 32.9059 3.67695 30.4058 3.41044C28.0707 3.15662 25.9259 3.82925
          24.0349 5.08566C22.0043 6.43091 20.088 7.97923 18.1589 9.48946C16.0268 11.1647 13.8567 12.7891
          11.2804 13.7156C8.86906 14.5913 6.43238 14.8705 3.97031 13.9694C1.87628 13.2079 0.480265 11.7612
          0.0741505 9.52754C-0.230435 7.8777 0.442191 6.4563 1.38133 5.16181C2.96771 3.01702 5.17596 1.72253
          7.59996 0.745316C7.65072 0.719934 7.71417 0.758007 7.90454 0.783389Z"
          fill="currentColor"
        />
        <path
          d="M22.0932 7.90334C22.2328 7.76374 22.3597 7.59876 22.512 7.47184C24.1364 6.12659 25.9259 5.06054
          27.9945 4.54021C29.0733 4.261 30.1012 4.33715 30.9515 5.14938C31.878 6.02506 32.0811 7.09111 31.5607
          8.27138C30.8627 9.83238 29.619 10.8984 28.3499 11.9518C28.0072 12.231 27.6519 12.4975 27.2838
          12.7386C27.1315 12.8402 26.9412 12.9036 26.7762 12.9925C26.7254 12.9417 26.6874 12.8909 26.6366
          12.8402C26.8396 12.599 27.0554 12.3579 27.2331 12.1041C27.9565 11.0253 28.8321 10.0101 29.3652
          8.84248C30.0759 7.30686 29.2383 6.10121 27.5377 6.15197C26.5985 6.17735 25.634 6.48194 24.7329
          6.79922C24.0095 7.05304 23.3623 7.5353 22.677 7.91603C22.5374 7.99218 22.3724 8.05563 22.2328
          8.11909C22.1693 8.03025 22.1313 7.9668 22.0932 7.90334Z"
          fill="currentColor"
        />
        <path
          d="M12.6383 7.16704C12.5748 7.24318 12.5367 7.34471 12.4606 7.39548C10.595 8.80419 8.56442 9.84485
          6.22926 10.1621C4.96015 10.3398 3.91949 9.921 3.25955 8.79149C2.59961 7.68737 2.87882 6.63401
          3.56414 5.64411C4.73171 3.96889 6.38155 2.87746 8.09485 1.86217C8.17099 1.81141 8.3106 1.84948
          8.5898 1.8241C8.33598 2.1033 8.19638 2.26828 8.05677 2.43327C7.26993 3.37241 6.47039 4.28616
          5.70893 5.25069C5.50587 5.50451 5.39165 5.84717 5.30281 6.16444C4.96015 7.33202 5.48049 8.2204
          6.67345 8.51229C8.0187 8.84226 9.26243 8.43614 10.4808 7.9285C11.0265 7.70006 11.5468 7.40817
          12.0798 7.15435C12.2321 7.0782 12.3971 7.04013 12.5494 6.98936C12.5748 7.05282 12.6129 7.10358
          12.6383 7.16704Z"
          fill="currentColor"
        />
        <path
          d="M23.2735 8.62633C24.3903 8.19483 25.5325 7.83948 26.7381 8.16945C27.03 8.2456 27.3473 8.63902
          27.4361 8.9563C27.6646 9.71776 26.7635 11.3803 25.9132 11.7991C25.9767 11.5833 26.002 11.4311
          26.0528 11.3041C26.1543 11.0249 26.3066 10.7711 26.3955 10.4919C26.7381 9.36241 26.332 8.77862
          25.1517 8.74055C24.7075 8.72786 24.276 8.79131 23.8319 8.82939C23.6542 8.84208 23.4892 8.85477
          23.3115 8.86746C23.2988 8.77862 23.2861 8.70248 23.2735 8.62633Z"
          fill="currentColor"
        />
        <path
          d="M9.18632 3.01697C8.91981 3.58807 8.67868 4.01956 8.50101 4.48913C8.18373 5.32674 8.50101 5.92322
          9.37669 6.08821C9.88433 6.18974 10.4174 6.13897 10.9504 6.15166C11.1407 6.15166 11.3311 6.15166
          11.5215 6.15166C11.5342 6.21512 11.5469 6.27857 11.5596 6.34203C11.3184 6.41818 11.09 6.55778
          10.8489 6.57047C10.0493 6.64661 9.24978 6.74814 8.46293 6.69738C7.56187 6.63392 7.11768 5.94861
          7.48572 5.12369C7.81569 4.3876 8.36141 3.75305 8.81828 3.08042C8.85636 3.04235 8.97058 3.05504
          9.18632 3.01697Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
}
